import React, { useEffect, useState } from "react";
import "../Footer/FooterNav.css";
import AddtoCart from "../../../Pages/AddtoCart";
import { Link, useLocation } from "react-router-dom";
import { useCartContext } from "../../../context/addToCart";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../../../services/localStorageServices";
import axios from "axios";

const navItems = [
  { name: "Home", icon: "home-outline", path: "/" },
  { name: "Product", icon: "pricetags-outline", path: "/product" },
  { name: "Cart", icon: "cart-outline", path: "#" }, // still opens offcanvas
  { name: "Order", icon: "receipt-outline", path: "/order" },
  { name: "Profile", icon: "person-outline", path: "/profile" },
];

const FooterNav = ({ someProp }) => {
  const [active, setActive] = useState("Home");
  const location = useLocation();
  const [isSticky, setIsSticky] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const { cartValue, setCartCount, setCartValue } = useCartContext();
  const { access_token } = getToken();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const { token } = useSelector((state) => state.auth);

  const handleScroll = () => {
    setIsSticky(window.scrollY > 20);
  };

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navbarClass = someProp ? "black-navbar" : "transparent-navbar";

  const handleFetch = async () => {
    try {
      setLoading(true);
      const resp = await axios.get(`https://api.woodsy.co.in/api/wood-images-new`);
      if (resp && resp.data) {
        const categoryArray = Array.isArray(resp.data)
          ? resp.data
          : Object.values(resp.data);
        setData(categoryArray);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const dbounce = setTimeout(() => {
      handleFetch();
    }, 1000);
    return () => {
      clearTimeout(dbounce);
    };
  }, []);

  const handleNavClick = (name) => {
    setActive(name);
    if (name === "Cart") {
      const cartToggleBtn = document.getElementById("cartToggleBtn");
      if (cartToggleBtn) cartToggleBtn.click();
    }
  };

  useEffect(() => {
    const currentItem = navItems.find((item) => item.path === location.pathname);
    if (currentItem) {
      setActive(currentItem.name);
    }
  }, [location.pathname]);

  return (
    <>
      {/* Hidden Button to trigger Bootstrap offcanvas */}
      <button
        id="cartToggleBtn"
        type="button"
        className="d-none"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasRight"
        aria-controls="offcanvasRight"
      ></button>

      <nav className={navbarClass}>
        <div className="nav-box">
          <ul className="nav-container">
            {navItems.map((item) => (
              <li
                key={item.name}
                className={`nav__item ${active === item.name ? "active" : ""}`}
                onClick={() => handleNavClick(item.name)}
              >
                {item.name === "Cart" ? (
                  <button className="nav__item-link bg-transparent border-0">
                    <div className="nav__item-icon">
                      <ion-icon name={item.icon}></ion-icon>
                    </div>
                    <span className="nav__item-text">{item.name}</span>
                  </button>
                ) : (
                  <Link to={item.path} className="nav__item-link">
                    <div className="nav__item-icon">
                      <ion-icon name={item.icon}></ion-icon>
                    </div>
                    <span className="nav__item-text">{item.name}</span>
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      </nav>

      {/* Bootstrap Offcanvas for Cart */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h5 id="offcanvasRightLabel">Your Cart</h5>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <AddtoCart />
        </div>
      </div>
    </>
  );
};

export default FooterNav;
